/**
 * The Spaces window: like Miro's home. Where you work now, the servers you are signed in to,
 * each with its teams and their spaces; making teams and spaces, inviting people, and the
 * invite you came with. The desktop app's own board stays on this computer whatever happens
 * here: a space is opened online, and left with "Back to this computer".
 *
 * One file per part: `Here.tsx` (where you work, the way back), `Pending.tsx` (an invite to
 * accept), `SignIn.tsx` (adding a server), `ServerSection.tsx` (one server's teams),
 * `TeamPanel.tsx` (one team: spaces, members, invites).
 */
import { For, type JSX } from "solid-js";
import { useApp } from "../../app/context";
import { Here } from "./Here";
import { Pending } from "./Pending";
import { ServerSection } from "./ServerSection";
import { SignIn } from "./SignIn";

/** The Spaces window. */
export function HomeWindow(): JSX.Element {
  const { accounts } = useApp();
  return (
    <div class="homewin" id="home">
      <Here />
      <Pending />
      <For each={accounts.sessions()}>{(session) => <ServerSection server={session.server} />}</For>
      <SignIn />
    </div>
  );
}
